import { render, staticRenderFns } from "./McpAuthorize.vue?vue&type=template&id=1a9ce9f9"
import script from "./McpAuthorize.vue?vue&type=script&lang=js"
export * from "./McpAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports